"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

var _axisLabelFormatterOptions = _interopRequireDefault(require("../label-formatters/axis-label-formatter-options"));

var _coerce = _interopRequireDefault(require("@meltwater/coerce"));

var _axisLabelFormatters = require("../label-formatters/axis-label-formatters");

var _highcharts = _interopRequireDefault(require("highcharts"));

var _logger = _interopRequireDefault(require("../logger"));

var _mwChartOneSeriesColumnClickOptions = _interopRequireDefault(require("./mw-chart-one-series-column-click-options"));

var _mwChartOneSeriesColumnLabelFormatterOptions = _interopRequireDefault(require("./mw-chart-one-series-column-label-formatter-options"));

var _mwChartOneSeriesColumnOptions = _interopRequireDefault(require("./mw-chart-one-series-column-options"));

var _mwChartOneSeriesColumnTooltipOptions = _interopRequireDefault(require("./mw-chart-one-series-column-tooltip-options"));

var _seriesData = _interopRequireDefault(require("../series-data"));

var _styles = require("../styles");

var BRIGHT_PERCENTAGE = 0.1;

function chartDataToHighchartsColumnData(data, selectedIndexPoints) {
  return data.map(function (column, index) {
    return {
      name: column.key,
      y: column.value,

      /*eslint-disable-line id-length*/
      selected: selectedIndexPoints.includes(index)
    };
  });
}
/**
 * A class for rendering a one series column chart
 */


var MwChartOneSeriesColumn =
/*#__PURE__*/
function () {
  /**
  * Create a new Column Chart
  * @param {string|HTMLElement} renderTarget - The id of, or the HTMLElement for, the element to render into. Note: this element will be emptied!
  */
  function MwChartOneSeriesColumn(renderTarget) {
    (0, _classCallCheck2.default)(this, MwChartOneSeriesColumn);

    if (!renderTarget) {
      throw new TypeError('renderTarget is required.');
    }

    this.__renderTarget = renderTarget;
  }
  /**
   * Set the chart data to be rendered
   * @param {SeriesData} chartData - The data to be rendered to the chart
   * @returns {undefined}
   */


  (0, _createClass2.default)(MwChartOneSeriesColumn, [{
    key: "setChartData",
    value: function setChartData(chartData) {
      this.__chartData = (0, _coerce.default)(chartData, _seriesData.default, "chartData should be shaped like a SeriesData. Provided value: ".concat(JSON.stringify(chartData)));
    }
    /**
     * Set the visualization options for the chart
     * @param {MwChartOneSeriesColumnChartOptions} chartOptions - The visualization options for the chart
     * @returns {undefined}
     */

  }, {
    key: "setChartOptions",
    value: function setChartOptions(chartOptions) {
      this.__chartOptions = (0, _coerce.default)(chartOptions, _mwChartOneSeriesColumnOptions.default, "chartOptions must be a valid MwChartDonutChartOptions object. Provided value: ".concat(JSON.stringify(chartOptions)));
    }
    /**
    * Render the chart to the renderTarget passed in the constructor
    * @returns {undefined}
    */

  }, {
    key: "render",
    value: function render() {
      try {
        this.error = false;

        if (!this.__renderTarget) {
          throw new Error('renderTarget not set. Unable to render visualization');
        }

        var safeHighchartOptions = this.__chartOptions;
        var safeSeriesColor = safeHighchartOptions.seriesColor;
        var columnChartData = chartDataToHighchartsColumnData(this.__chartData.data, safeHighchartOptions.selectedIndexPoints);

        var selectedColumnFillColor = _highcharts.default.Color(safeSeriesColor).brighten(BRIGHT_PERCENTAGE).get(); // eslint-disable-line new-cap


        var safeDataLabelFormatter = function safeDataLabelFormatter() {
          var options = new _mwChartOneSeriesColumnLabelFormatterOptions.default({
            /* eslint-disable no-invalid-this */
            key: this.key,
            value: this.y
            /* eslint-enable no-invalid-this */

          });
          return safeHighchartOptions.dataLabelFormatter(options);
        };

        var safeOnPointClick = function safeOnPointClick(event) {
          var options = new _mwChartOneSeriesColumnClickOptions.default(event);
          return safeHighchartOptions.onPointClick(options);
        };

        var safeTooltipFormatter;
        var enableToolip = false;

        if (safeHighchartOptions.tooltipFormatter) {
          enableToolip = true;

          safeTooltipFormatter = function safeTooltipFormatter() {
            var options = new _mwChartOneSeriesColumnTooltipOptions.default(this); // eslint-disable-line no-invalid-this

            return safeHighchartOptions.tooltipFormatter(options);
          };
        }

        var resolvedYAxisLabelFormatter;

        if (typeof safeHighchartOptions.yAxisLabelFormatter === 'string') {
          resolvedYAxisLabelFormatter = (0, _axisLabelFormatters.getFormatter)(safeHighchartOptions.yAxisLabelFormatter);
        } else {
          resolvedYAxisLabelFormatter = safeHighchartOptions.yAxisLabelFormatter;
        }

        var safeYAxisLabelFormatter = function safeYAxisLabelFormatter() {
          var options = new _axisLabelFormatterOptions.default({
            /* eslint-disable no-invalid-this */
            isFirst: this.isFirst,
            isLast: this.isLast,
            value: this.value
            /* eslint-enable no-invalid-this */

          });
          return resolvedYAxisLabelFormatter(options);
        };

        _highcharts.default.chart(this.__renderTarget, {
          title: {
            text: ''
          },
          chart: {
            renderTo: this.__renderTarget,
            reflow: false,
            type: 'column',
            style: {
              fontFamily: _styles.FONT_FAMILY,
              color: _styles.AXIS_LABEL_FONT_COLOR
            }
          },
          credits: {
            enabled: false
          },
          exporting: {
            enabled: false
          },
          legend: {
            enabled: false
          },
          xAxis: {
            type: 'category',
            lineColor: _styles.LINE_AND_TICK_COLOR,
            labels: {
              style: {
                color: _styles.AXIS_LABEL_FONT_COLOR
              }
            },
            lineWidth: _styles.X_AXIS_LINE_WIDTH,
            tickColor: _styles.LINE_AND_TICK_COLOR
          },
          yAxis: {
            title: {
              text: safeHighchartOptions.yAxisTitle,
              style: {
                color: _styles.AXIS_LABEL_FONT_COLOR,
                fontFamily: _styles.FONT_FAMILY,
                fontWeight: _styles.AXIS_LABEL_FONT_WEIGHT
              }
            },
            labels: {
              formatter: safeYAxisLabelFormatter,
              style: {
                color: _styles.AXIS_LABEL_FONT_COLOR
              }
            },
            gridLineColor: _styles.LINE_AND_TICK_COLOR
          },
          tooltip: {
            enabled: enableToolip,
            formatter: safeTooltipFormatter,
            useHTML: true
          },
          plotOptions: {
            column: {
              dataLabels: {
                enabled: true,
                formatter: safeDataLabelFormatter,
                style: {
                  color: _styles.AXIS_LABEL_FONT_COLOR,
                  fontWeight: _styles.AXIS_LABEL_FONT_WEIGHT
                }
              },
              events: {
                click: safeOnPointClick
              },
              states: {
                select: {
                  borderWidth: _styles.COLUMN_SELECT_BORDER_WIDTH,
                  color: selectedColumnFillColor
                }
              }
            }
          },
          series: [{
            data: columnChartData,
            color: safeSeriesColor
          }]
        });
      } catch (error) {
        this.error = true;

        _logger.default.error('Chart failed to render.', error);
      }
    }
  }]);
  return MwChartOneSeriesColumn;
}();

exports.default = MwChartOneSeriesColumn;